export const APP_BASE_URL =
  process.env.REACT_APP_ENV === 'local'
    ? 'http://localhost:3000'
    : window.location.origin;

export const APP_API_BASE_URL =
  process.env.REACT_APP_ENV === 'local'
    ? 'http://localhost:8000/api'
    : `${window.location.origin}/api`;
